<template>
  <div class="kanban-view">
    <div
      class="each-block"
      v-for="(listing, statusIndex) in status_wise"
      :key="statusIndex"
    >
      <div class="flex mb-2">
        <div class="flex w-full card-title">
          <h6 class="mr-3">{{ listing.status_name }}</h6>
          <h6 class="mr-3">{{ listing.leads.length }}</h6>
        </div>
      </div>
      <draggable
        class="py-2 cursor-move h-full"
        group="leads_status_id"
        :list="listing.leads"
        :move="checkMove"
        :id="listing.status_id"
      >
        <vs-card
          v-for="(item, leadIndex) in listing.leads"
          :key="leadIndex"
          class="mb-4"
        >
          <!-- <pre>{{item}}</pre> -->
          <!-- <div class="flex justify-between items-center">
            <div>
              <span>{{ item.status_details.status_name }}</span>
            </div>
            <div class="switch-container">
            <toggle-button
                  :value="item.is_active"
                  :color="{
                    checked: '#35C76F',
                    unchecked: '#EA5455',
                    disabled: '#CCCCCC',
                  }"
                  class="mr-1"
                  @change="
                    setActiveDeactiveForLeads(
                      item,
                      item.is_active,
                      item.leads_id,
                      statusIndex,
                      leadIndex
                    )"
                />
            </div>
          </div> -->
          <vs-row
            style="border-bottom: 1px solid #dbdbdb;"
            class="card-data kanban_card_data"
            vs-type="flex"
            vs-justify="space-between"
            vs-align="center"
          >
            <div
              class="flex justify-between items-center w-full kaban-avatar-tooltip"
              v-if="
                item.lead_first_name ||
                item.lead_middle_name ||
                item.lead_last_name
              "
            >
              <div class="flex">
                <vs-checkbox @change="handleChange(item)" :checked="checkedIds[item.leads_id]"></vs-checkbox>
                <image-cell
                  :detail = "item"
                ></image-cell>
              </div>

              <div>
                <vs-dropdown>
                  <feather-icon class="action-menu" icon="MoreVerticalIcon" />

                  <vs-dropdown-menu>
                    <!-- <vs-dropdown-item>
                                        + Todo
                                    </vs-dropdown-item>
                                    <vs-dropdown-item>
                                        + Note
                                    </vs-dropdown-item>
                                    <vs-dropdown-item>
                                        + Meeting
                                    </vs-dropdown-item>
                                    <vs-dropdown-item>
                                        + Email
                                    </vs-dropdown-item> -->
                    <vs-dropdown-item
                      v-if="checkEditPermission()"
                      @click="editData(item)"
                    >
                      Edit
                    </vs-dropdown-item>
                    <vs-dropdown-item
                      v-if="checkEditPermission()"
                      @click="hanldeViewSidebar(item)"
                    >
                      Preview
                    </vs-dropdown-item>
                    <!--  <vs-dropdown-item>
                                        Duplicate
                                    </vs-dropdown-item> -->
                    <vs-dropdown-item
                      v-if="checkDeletePermission()"
                      @click="openConfirmationModal"
                    >
                      Delete
                    </vs-dropdown-item>
                    <vs-dropdown-item
                      @click="setActiveDeactiveForLeads(
                          item,
                          item.is_active,
                          item.leads_id,
                          statusIndex,
                          leadIndex
                        )"
                    >
                      {{ item.is_active? 'Inactive' : 'Activate' }}
                    </vs-dropdown-item>
                    <!--  <vs-dropdown-item>
                                        Unsubscribe
                                    </vs-dropdown-item> -->
                  </vs-dropdown-menu>
                </vs-dropdown>
              </div>
            </div>
            <!-- <vs-col vs-w="5" v-if="item.lead_middle_name">
                            <b>Middle Name: </b>
                        </vs-col>
                        <vs-col vs-w="7" v-if="item.lead_middle_name">
                            <span>{{item.lead_middle_name}}</span>
                        </vs-col>
                         <vs-col vs-w="5" v-if="item.lead_last_name">
                            <b>Last Name: </b>
                        </vs-col>
                        <vs-col vs-w="7"  v-if="item.lead_last_name">
                            <span>{{item.lead_last_name}}</span>
                        </vs-col> -->
            <div
              class="flex w-full"
              v-if="item.email"
            >
              <div class="flex mr-2">
                <span class="material-icons-outlined">email</span>
              </div>
              <div>
                <strong class="block w-full">Email:</strong>
                <span>{{ item.email }}</span>
              </div>
            </div>
            <div
              class="flex items-center w-full"
              v-if="item.phone"
            >
              <!-- <div class="flex mr-2">
                <span class="material-icons-outlined">phone</span>
              </div> -->
              <phone-image-cell :phone="item.phone" :country_code="item.country_details? item.country_details.country_code : ''" :country_name="item.country_details? item.country_details.country_name : 'N/A'"></phone-image-cell>
            </div>
            <!-- <vs-col vs-w="5" v-if="item.lead_state">
                            <b>State:</b>
                        </vs-col>
                        <vs-col vs-w="7" v-if="item.lead_state">
                            <span>{{ item.lead_state }}</span>
                        </vs-col> -->
            <!-- <vs-tooltip
              color="primary"
              text="Address"
              position="left"
              class="flex items-center w-full my-1"
              v-if="
                item.lead_address1 ||
                item.lead_state ||
                item.lead_zip ||
                item.lead_city
              "
            >
              <div class="flex mr-2">
                <vs-tooltip
                  class="flex"
                  color="primary"
                  text="Address"
                  position="top"
                >
                  <span class="material-icons-outlined">location_on</span>
                </vs-tooltip>
              </div>
              <div>
                <span v-if="item.lead_address1"
                  >{{ item.lead_address1 }},
                </span>
                <span v-if="item.lead_city">{{ item.lead_city }}, </span>
                <span v-if="item.lead_state">{{ item.lead_state }}, </span>
                <span v-if="item.lead_zip">{{ item.lead_zip }}</span>
              </div>
            </vs-tooltip> -->
            <!-- <vs-col vs-w="5" v-if="item.lead_zip">
                            <b>Zip:</b>
                        </vs-col>
                        <vs-col vs-w="7" v-if="item.lead_zip">
                            <span>{{ item.lead_zip }}</span>
                        </vs-col> -->
            <!-- <vs-tooltip
              color="primary"
              text="Country"
              position="left"
              class="flex items-center w-full my-1"
              v-if="item.country_details"
            >
              <div class="flex mr-2">
                <span class="material-icons-outlined">public</span>
              </div>
              <div>
                <span>{{ item.country_details.country_name }}</span>
              </div>
            </vs-tooltip> -->
            <!-- <vs-col vs-w="5" v-if="item.lead_city">
                            <b>City:</b>
                        </vs-col>
                        <vs-col vs-w="7" v-if="item.lead_city">
                            <span>{{ item.lead_city}}</span>
                        </vs-col> -->
            <!-- <vs-tooltip
              color="primary"
              text="Status"
              position="left"
              class="flex items-center w-full my-1"
            >
              <div class="flex mr-2">
                <span class="material-icons">label_important</span>
              </div>
              <div>
                {{ listing.status_name }}
                <span>{{ item.status_details.status_name }}</span>
              </div>
            </vs-tooltip> -->
            <!-- <vs-tooltip
              color="primary"
              text="Tags"
              position="left"
              class="flex items-center w-full my-1"
              v-if="item.tags.length > 0"
            >
              <div class="flex mr-2">
                <span class="material-icons">sell</span>
              </div>
              <div>
                <span v-for="(item1, index) in item.tags" :key="index"
                  >{{ item1.tag ? item1.tag.name : "" }},</span
                >
              </div>
            </vs-tooltip> -->
            <!-- <vs-tooltip
              color="primary"
              text="Created at"
              position="left"
              class="flex items-center w-full my-1"
            >
              <div class="flex mr-2">
                <span class="material-icons">today</span>
              </div>
              <div>
                <span>{{ item.created_at | dateFormatLocalization }}</span>
              </div>
            </vs-tooltip> -->
            <div class="flex items-center w-full my-1 pb-4">
              <tag-show :tags="item.tags"></tag-show>
            </div>
          </vs-row>
          
          <div class="tag-container">
            <!-- <span class="tag-holder">
                            <feather-icon icon="TagIcon" />Music
                        </span>
                        <span class="tag-holder">
                            <feather-icon icon="TagIcon" />Singing
                        </span> -->
          </div>
          <!-- <div class="assigned-container"> -->
          <!-- <span class="assigned-holder"> -->
          <!-- <feather-icon icon="UserCheckIcon" /> -->
          <!-- </span> -->
          <!-- <b><pre>{{item}}</pre></b> -->
          <!-- </div> -->
          
          <div class="flex action-container">
            <!-- <feather-icon
              class="action-menu"
              icon="EyeIcon"
              @click="hanldeViewSidebar(item)"
            /> -->
            <div
              class="flex items-center w-full my-1"
            >
              <!-- <vs-button
                class="mr-2"
                icon-pack="feather"
                type="filled"
                @click="cellSingleClick(item)"
                icon="icon-eye"
                color="primary"
              /> -->
              <vs-button
                class="w-full"
                type="filled"
                @click="cellSingleClick(item)"
                color="primary"
              >View Details</vs-button>
            </div>
          </div>
          <vs-popup
          classContent="popup-example"
          title="Please Confirm"
          :active.sync="showPopUpBool"
          >
          <h4>Are you sure to delete?</h4>
          <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
            <vs-button class="mr-2" @click="deleteLead(item.leads_id, statusIndex, leadIndex)">Confirm</vs-button>
            <vs-button type="border" color="danger" @click="showPopUpBool = false"
              >Cancel</vs-button
            >
          </vs-row>
        </vs-popup>
        </vs-card>
      </draggable>
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
import { PermissionMiddleware } from "../../../mixins/middleware/PermissionMiddleware";
import draggable from "vuedraggable";
import { changeLeadStatus } from "@/api/leaddetails";
import { activeDeactiveLeads, Delete_Leads } from "@/api/leads";
import { mapActions } from "vuex";
import { ToggleButton } from "vue-js-toggle-button";
import TagShow from "./TagShow";
import PhoneImageCell from "./PhoneImageCell";
import ImageCell from "./ImageCell";
import router from '@/router';

export default {
  name: "kanban",
  components: {
    draggable,
    ToggleButton,
    TagShow,
    PhoneImageCell,
    ImageCell,
  },
  props: {
    leadlist: {
      type: Array,
      default: () => [],
    },
    active_status_list: {
      type: Array,
      default: () => [],
    },
  },
  mixins: [PermissionMiddleware],
  created() {
    const role_permission = parseInt(localStorage.getItem("role_permission"));
    if (role_permission === 1) {
      this.schoolAdmin = true;
    } else {
      this.schoolAdmin = false;

      this.getModulePermission("CRM");
    }
  },
  data() {
    return {
      active2: [],
      datalist: [],
      checkbox: true,
      //dividearray:[],
      status_wise: [],
      //   statuslist:[]
      checkedIds: [],
      selectedIds: [],
      selectedItems: [],
      showPopUpBool: false
    };
  },
  mounted() {
    this.statusWiseLeadList();
  },
  watch: {
    leadlist: {
      deep: true,
      handler() {
        this.statusWiseLeadList();
      },
    },
  },
  methods: {
    ...mapActions([
      "SET_VIEW_LEADS_SIDEBAR",
      "SET_VIEW_LEADS_SIDEBAR_DATA",
      "SET_DELETE_ID",
      "SET_LEADS_TOGGLE_DATA",
    ]),
    editData(lead) {
      if (!lead.is_active) {
        this.$vs.notify({
          title: "Warning",
          text: "Can\'t edit inactive lead",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
        });
        return false
      }
      const leadId = lead.leads_id 
      this.$router.push({ name: "lead-edit", params: { leadId } });
    },
    openConfirmationModal() {
      this.showPopUpBool = true
    },
    handleChange(item) {
      const leadId = item.leads_id
      if (!this.selectedIds.includes(leadId)) {
        this.selectedIds.push(leadId)
        this.selectedItems.push(item)
      } else {
        const index = this.selectedIds.indexOf(leadId);
        if (index > -1) {
          this.selectedIds.splice(index, 1)
          this.selectedItems.splice(index, 1)
        }
      }
      
      this.$emit('minTwoRowSelected', this.selectedIds.length )
      this.$emit('getSelectedKanbanRows', this.selectedItems )

    },
    cellSingleClick(item) {
      router.push({
          name: 'leadDetails',
          params: { leadId: parseInt(item.leads_id) }
        })
    },
    async deleteLead(id, statusIndex, leadIndex) {
      try {
        const payload = {
          leads_id: [id],
          customer_id: this.$store.getters.customerId,
        };
        // console.log(this.status_wise[statusIndex].leads[leadIndex].is_active)
        if (this.status_wise[statusIndex].leads[leadIndex].is_active == 0) {
          const data = await Delete_Leads(payload);
          this.SET_DELETE_ID(id);
          this.showPopUpBool = false
          this.$vs.notify({
            title: "Lead deleted",
            text: "Lead deleted successfully",
            ...this.successProp(),
          });
          /*   console.log(this.status_wise[statusIndex].leads.splice(leadIndex, 1))
        console.log(id)
        console.log(statusIndex)
        console.log(leadIndex) */
        } else {
          this.$vs.notify({
            title: "Warning",
            text: "Can’t remove an active lead. Please deactivate the lead first",
            ...this.warnProp(),
          });
        }
      } catch (error) {
        console.warn(error);
      }
    },
    statusWiseLeadList() {
      const status_name = this.active_status_list.map((ele) => {
        return {
          status_id: ele.leads_status_id,
          status_name: ele.status_name,
          sequence_numer: ele.status_sequence,
        };
      });
      status_name.forEach((element) => {
        //   status_name['data'] = element.status_id
        const similarStatus = this.leadlist.filter((ele) => {
          if (ele.is_active == "1") {
            ele.is_active = true;
          } else {
            ele.is_active = false;
          }
          return element.status_id === ele.leads_current_status_id;
        });
        Object.assign(element, { leads: similarStatus });
      });

      this.status_wise = status_name;
    },
    hanldeViewSidebar(item) {
      this.SET_VIEW_LEADS_SIDEBAR(true);
      this.SET_VIEW_LEADS_SIDEBAR_DATA(item);
    },
    checkMove(evt) {
      if (evt.draggedContext.element.is_converted === "0") {
        const leads_id = evt.draggedContext.element.leads_id;
        const changestatusTo = evt.to.id;
        const changestatusFrom = evt.from.id;

        const sequence_number = this.active_status_list.find((element) => {
          return element.leads_status_id == changestatusTo;
        });
        const sendStatusObject = {
          leads_id,
          form_status_id: changestatusFrom,
          to_status_id: changestatusTo,
          leads_status_order_number: sequence_number.status_sequence,
          customer_id: this.$store.getters.customerId,
        };
        if (changestatusTo !== changestatusFrom) {
          this.changeLeadStatus(sendStatusObject);
        }
      } else {
        // this.$vs.notify({
        //   title: 'Error',
        //   text: "Leads already converted into account",
        //   iconPack: 'feather',
        //   icon: 'icon-alert-circle',
        //   color: 'warning'
        // })
        return false;
      }
    },

    async changeLeadStatus(payload) {
      this.$vs.loading();
      //   const requestParameter = {
      //     leads_id : this.leaddetails.id,
      //     form_status_id : this.leadsCurrentStatusId,
      //     to_status_id : statusId,
      //     leads_status_order_number:sequenceNumber,
      //     customer_id : this.$store.getters.customerId
      //   }
      //get the selected button index number
      // const elementsIndex = this.leadstatus.findIndex(element => element.status_sequence === sequenceNumber)
      // const length = this.leadstatus.length

      try {
        await changeLeadStatus(payload);
        this.$vs.loading.close();

        this.$vs.notify({
          title: "Success",
          text: "Status changed successfully",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success",
        });
      } catch (apiError) {
        this.$vs.loading.close();
      }
    },
    async setActiveDeactiveForLeads(
      item,
      isActive,
      leadsId,
      statusIndex,
      leadIndex
    ) {
      try {
        if (isActive) {
          isActive = 0;
        } else {
          isActive = 1;
        }
        const requestParameter = {
          leads_id: leadsId,
          type: isActive,
        };
        const data = await activeDeactiveLeads(requestParameter);
        item.is_active = !item.is_active;
        this.status_wise[statusIndex].leads[leadIndex] = item;
        const storePayload = {
          row_details: item,
          toggle: item.is_active,
        };
        this.SET_LEADS_TOGGLE_DATA(storePayload);
        this.$emit("kanbanData", item);
        let text = "";
        if (isActive == 1) {
          text = "Lead activated successfully";
        } else {
          text = "Lead dectivated successfully";
        }

        this.$vs.notify({
          title: "Success",
          text,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success",
          time: 3000,
        });
      } catch (apiError) {
        console.warn(apiError);
        this.$vs.notify({
          title: "Warning",
          text: apiError.data,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center",
        });
      }
    },
  },
};
</script>

<style>
.kanban-view {
  display: flex;
  width: 100%;
  /* height: 60vh; */
  overflow: auto;
  margin: 10px 0;
}

.each-block {
  display: inline-block;
  min-width: 300px;
  max-width: 300px;
  margin-right: 20px;
  padding: 10px;
  border-radius: 8px;
  word-break: break-all;
}
.card-title {
  padding: 16px;
  border-radius: 6px;
  height: 50px;
  background-color: #ffffff;
  justify-content: space-between;
}
.card-title h6 {
  font-size: 16px;
  font-family: "Montserrat";
  font-weight: 700;
  line-height: 18px;
  color: #4b4b4b !important;
}
.each-block .vs-card--content,
.each-block .con-vs-card {
  margin-bottom: 0;
}

.card-data {
  box-shadow: 0 10px 15px -10px rgba(0, 0, 0, 0.05);
  margin: 10px 0 15px;
}

.tag-holder {
  display: inline-flex;
  align-items: center;
  background-color: #eae6ff;
  color: #403294;
  padding: 2px 4px;
  border-radius: 4px;
  font-weight: bold;
  margin-right: 5px;
  margin-bottom: 5px;
}

.each-block svg {
  width: 15px;
}

.tag-holder svg {
  margin-right: 5px;
}

.assigned-container {
  display: inline-flex;
  align-items: center;
  width: calc(100% - 60px);
}

.assigned-holder {
  display: inline-flex;
  align-items: center;
  background-color: #63ba3c;
  color: #fff;
  border-radius: 4px;
  padding: 2px 6px;
  margin-right: 5px;
}

.time-holder {
  display: inline-flex;
  align-items: center;
  color: #4b4b4b;
  border-radius: 4px;
  padding: 2px 4px;
  margin-top: 5px;
  font-weight: bold;
}

.time-holder svg {
  margin-right: 5px;
}

.action-container {
  display: inline-flex;
  justify-content: end;
}

.action-container svg {
  margin-left: 5px;
  color: #403294;
}

.action-btn {
  width: auto !important;
  height: auto !important;
  padding: 5px !important;
}

.action-menu {
  width: 25px;
  cursor: pointer;
}

.kanban_card_data > .con-vs-tooltip span.material-icons-outlined,
.kanban_card_data > .con-vs-tooltip span.material-icons {
  font-size: 20px;
}

.deactive-style {
  color: #f15d5f;
}

.kaban-avatar-tooltip {
  padding-bottom: 8px;
  border-bottom: 1px solid #dbdbdb;
  margin-bottom: 20px;
}
.con-vs-checkbox {
  margin-left: 0px !important;
}
</style>
